import React from "react"
import AppCollection from "./AppCollection"
import PromoCard from "./PromoCard"

const PageDefaultLayout = ({ tab, tabItems }) => {
  return tabItems
    .map(({ appCollection, promoCard }, i) => {
      return <React.Fragment key={i}>
        {appCollection && <AppCollection
          id={appCollection.id}
          total={appCollection.total}
          limit={appCollection.limit}
          title={appCollection.title}
          layout={appCollection.layout}
          cardType={appCollection.cardType}
          showIcon={appCollection.showIcon}
          showBanner={appCollection.showBanner}
          showVideo={appCollection.showVideo}
          apps={appCollection.apps}

          // reporting
          tab={tab}
          appCollection={appCollection}
        />}

        {promoCard && <PromoCard
          imageUrl={promoCard.imageUrl}
          title={promoCard.title}

          // reporting
          tab={tab}
          promoCard={promoCard} />}
      </React.Fragment>
    })
}

export default PageDefaultLayout
